import { type Enrollment, EnrollmentStatus, type EnrollmentResponse } from "./enrollment";

export interface EnrollmentOutcomeLogFields {
    enrollmentStatus: string;
    productOfferId: string;
    confirmationCode?: string;
    reason?: string;
}

export const buildEnrollmentOutcomeLog = (
    enrollment: Enrollment,
    result: EnrollmentResponse,
): EnrollmentOutcomeLogFields => {
    const isSuccess = result.enrollmentStatus === EnrollmentStatus.Success;
    return {
        enrollmentStatus: result.enrollmentStatus,
        productOfferId: enrollment.productOfferId,
        ...(isSuccess ? { confirmationCode: enrollment.confirmationCode } : { reason: result.reason }),
    };
};
